import React from 'react';

const LogoFull: React.FC = () => {
  return (
    <svg viewBox="0 0 180 42" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <polygon id="path-1" points="0 0.184769585 36.6100922 0.184769585 36.6100922 41.0598871 0 41.0598871"></polygon>
      </defs>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-216.000000, -19.000000)">
          <g transform="translate(216.000000, 19.000000)">
            <path
              d="M102.447,24.5416313 C103.38018,26.094235 105.423429,27.2897419 107.091747,27.2897419 C108.731447,27.2897419 109.824512,26.4845115 109.824512,25.3051797 C109.824512,24.1542581 108.990249,23.3490276 106.976654,22.6584747 L105.250894,22.0546037 C101.9717,20.9038894 100.2167,19.0053871 100.2167,16.2151797 C100.2167,12.360318 103.150825,10.0879217 107.120571,10.0879217 C109.623152,10.0879217 111.915249,10.9783825 113.77041,13.1164009 L110.931055,15.8765392 C109.969465,14.6549032 108.558912,14.0000184 107.149189,14.0000184 C105.739673,14.0000184 104.416631,14.6043041 104.416631,15.8122535 C104.416631,17.0494424 105.423429,17.595871 107.580733,18.3724839 L109.220433,18.9765622 C112.212207,20.0696267 114.081677,21.968129 114.081677,25.0459631 C114.05306,28.6992581 111.14776,31.2020461 106.919212,31.2020461 C103.668636,31.2020461 100.882369,29.7379908 99.4152028,27.494212 L102.447,24.5416313 Z"
              id="Fill-1"
              fill="#2A2D36"
            ></path>
            <path
              d="M124.524643,24.6851129 C125.457823,26.2377166 127.644366,27.2899286 129.312892,27.2899286 C130.952592,27.2899286 132.045864,26.4844908 132.045864,25.305159 C132.045864,24.1542373 131.211394,23.3490069 129.198007,22.6584539 L127.471832,22.0545829 C124.192638,20.9038687 122.437846,19.0053664 122.437846,16.215159 C122.437846,12.3602972 125.37197,10.0879009 129.341717,10.0879009 C131.844297,10.0879009 134.136394,10.9783618 135.991555,13.1163802 L133.1522,15.8765184 C132.190611,14.6548825 130.780058,13.9999977 129.370541,13.9999977 C127.961025,13.9999977 126.637776,14.6042834 126.637776,15.8122327 C126.637776,17.0494217 127.644366,17.5958502 129.801878,18.3726705 L131.441578,18.9765415 C134.433353,20.069606 136.30303,21.9681083 136.30303,25.0459424 C136.274205,28.6992373 133.368906,31.2020253 129.140357,31.2020253 C125.889781,31.2020253 122.960012,29.8814724 121.493053,27.6376935 L124.524643,24.6851129 Z"
              id="Fill-3"
              fill="#2A2D36"
            ></path>
            <polygon
              fill="#2A2D36"
              points="46.8816843 10.433053 51.0527903 10.433053 51.0527903 18.5739055 59.912606 18.5739055 59.912606 10.433053 64.083712 10.433053 64.083712 30.8568318 59.912606 30.8568318 59.912606 22.5434447 51.0527903 22.5434447 51.0527903 30.8568318 46.8816843 30.8568318"
            ></polygon>
            <path
              d="M82.5242765,31.2019839 C77.6342074,31.2019839 74.2110968,27.8939654 74.2110968,22.8025369 L74.2110968,10.4331359 L78.3822028,10.4331359 L78.3822028,22.8597719 C78.3822028,25.5639194 80.0505207,27.1747949 82.5242765,27.1747949 C84.9982396,27.1747949 86.666765,25.5639194 86.666765,22.8597719 L86.666765,10.4331359 L90.8376636,10.4331359 L90.8376636,22.8025369 C90.8376636,27.8939654 87.3569032,31.2019839 82.5242765,31.2019839"
              id="Fill-7"
              fill="#2A2D36"
            ></path>
            <polygon
              fill="#2A2D36"
              points="145.439689 10.433053 149.610795 10.433053 149.610795 26.8870853 158.355518 26.8870853 158.355518 30.8568318 145.439689 30.8568318"
            ></polygon>
            <polygon
              fill="#2A2D36"
              points="167.101776 10.433053 179.816247 10.433053 179.816247 14.4027995 171.272882 14.4027995 171.272882 18.6027304 178.090279 18.6027304 178.004219 22.5720622 171.272882 22.5720622 171.272882 26.8870853 179.816247 26.8870853 179.816247 30.8568318 167.101776 30.8568318"
            ></polygon>
            <g transform="translate(0.000000, 0.022604)">
              <mask id="mask-2" fill="white">
                <use href="#path-1"></use>
              </mask>
              <g id="Clip-14"></g>
              <polygon
                id="Fill-13"
                fill="#B4FA05"
                mask="url(#mask-2)"
                points="27.5559677 41.0598871 21.3229493 37.5171221 21.3229493 25.8384816 6.10154378 41.0598871 0 37.5171221 11.8422581 11.7837581 9.19451613 13.753182 5.05182028 8.05829724 17.352788 0.184748848 23.4881336 3.66260599 14.7291014 22.278712 23.4906221 13.5064078 28.7369585 16.4562926 28.713318 29.4888733 32.2496544 26.0526982 36.6100922 32.0057627"
              ></polygon>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export { LogoFull };
